var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVideoOn = function SvgVideoOn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M15.722 7.813V4.457c0-.527-.425-.958-.944-.958H3.444c-.519 0-.944.431-.944.958v9.584c0 .527.425.958.944.958h11.334c.52 0 .944-.431.944-.958v-3.354l2.163 2.194c.595.604 1.615.173 1.615-.68V6.289c0-.853-1.02-1.284-1.615-.68l-2.163 2.204z",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    d: "M0 0H21V18H0z",
    transform: "translate(.5)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVideoOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/video-on.68061adb132e72444e38a1e73ef23056.svg";